import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth.service";
import {DEFAULT_RECORD_PATH, ROLE_PATHS} from "../constants/role-paths.constants";

export const roleRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userRole = authService.getRolesAndLogin().role;
  const redirectTo = ROLE_PATHS[userRole] || DEFAULT_RECORD_PATH;

  router.navigate([redirectTo]);
  return false;
};
